import { MonitorSmartphone, ExternalLink } from 'lucide-react';
import { Button } from '../../ui/button';
import { Card } from '../../ui/card';

const QUICK_LINKS = [
  'https://duckduckgo.com',
  'https://developer.mozilla.org',
  'https://www.example.com',
];

export const BrowserFallback = () => {
  const openUrl = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="flex h-full items-center justify-center bg-gradient-to-br from-background to-muted/40 p-6">
      <Card className="max-w-2xl space-y-5 border-border/70 bg-background/95 p-6 shadow-lg">
        <div className="flex items-start gap-4">
          <div className="rounded-xl bg-primary/10 p-3 text-primary">
            <MonitorSmartphone className="h-6 w-6" />
          </div>
          <div className="space-y-2">
            <h2 className="text-xl font-semibold">MapleBrowser native mode requires Electron</h2>
            <p className="text-sm text-muted-foreground">
              MapleBrowser now uses Electron&apos;s native browser engine instead of the legacy iframe/proxy browser. That choice gives modern websites normal browser behavior and avoids the poor performance and compatibility trade-offs of a WASM browser runtime.
            </p>
          </div>
        </div>

        <div className="rounded-lg border border-border/70 bg-muted/30 p-4 text-sm text-muted-foreground">
          Open MapleOS in the Electron desktop build to get native tabs, popup-to-tab handling, and download routing into the MapleOS Downloads folder.
        </div>

        <div className="flex flex-wrap gap-2">
          {QUICK_LINKS.map((url) => (
            <Button key={url} type="button" variant="outline" onClick={() => openUrl(url)}>
              <ExternalLink className="mr-2 h-4 w-4" />
              {new URL(url).hostname}
            </Button>
          ))}
        </div>
      </Card>
    </div>
  );
};
